module.exports = __webpack_public_path__ + "static/media/1_pl.5a8fa782.png";